import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import EditorLink from 'lowcode/components/EditorLink';
import ProductHeader from '../ProductHeader';
import styled from './index.module.scss';
import { imgList, imgList2, imgList3 } from './imgConfig';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useProductList } from '@/components/MembersDay/utils';
import { IPageStatus, IProductProps, ProductModule } from '@/components/MembersDay/type';
import { EuEcoCredits } from '@/components/MembersDay/FY2024/CommonElement/EuEcoCredits';
import Button from '@/components/UI/Button';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import gtm from '@/utils/gtm';
import { EU_SITES, NA_SITES, SAVE_SITES } from '@/constants/membersday';
import { signupCookie } from '@/utils/cookies/signupCookie';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';

const HotBundles: FC<IProductProps> = ({ module, icon, title, desc, id = 'activity-HotBundles' }) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);
    const { isLogin, pageStatus } = useMembersStore();

    let imgArr = imgList['us'];

    if (pageStatus === IPageStatus.ACTIVITY && imgList[locale]) {
        imgArr = imgList[locale];
    } else if (pageStatus === IPageStatus.RETURN && imgList2[locale]) {
        imgArr = imgList2[locale];
    }

    // 这个产品模块 特殊处理 只有一个产品 使用imgList3 并且 有两个btn！
    const euLearnMoreBtn = pageStatus === IPageStatus.RETURN && module === ProductModule.NORMAL2 && EU_SITES.includes(locale);
    if (euLearnMoreBtn) {
        imgArr = imgList3[locale];
    }

    const handleDetail = (data: any) => {
        if (isLogin || NA_SITES.includes(locale)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: title,
                product_name: data.title,
                price: data.memberPrice,
                tag: 'none',
                quantity: 1,
                button_name: t('product_price_buy_now'),
            });
            const { compareAtPrice, memberPrice, inventoryQuantity, title, variantId, productId, imageUrl } = data;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    compareAtPrice: Number(compareAtPrice),
                    price: Number(memberPrice),
                    inventoryQuantity,
                    inventoryPolicy: data?.inventoryPolicy || 'deny',
                    productTitle: data?.productTitle || title,
                    skuTitle: data?.skuTitle || title,
                    variantId,
                    productId,
                    img: data?.img || imageUrl,
                    variantImg: data?.variantImg || imageUrl,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_join_login',
                list_name: title,
                button_name: t('product_price_buy_now'),
            });
            const pathname2 = location.pathname;
            signupCookie?.({
                sector_name: title,
                entry_position: 3,
            });
            location.href = `/${locale}/login?redirect=${pathname2}`;
        }
    };

    return (
        <div className={`${styled.HotBundles}`} id={id}>
            <ProductHeader icon={icon} title={title} desc={desc} />
            <div className="product_box">
                {productList.map((item, index) => (
                    <div key={item.variantId} className={`product_item ${index % 2 === 1 ? 'right' : ''}`}>
                        <div className="context">
                            <div className="context-info">
                                {/* kr 这个位置3倍积分，特殊判断，我能怎么办，我也很绝望啊 */}
                                {locale === 'kr' && (pageStatus === IPageStatus.ACTIVITY || pageStatus === IPageStatus.RETURN) ? (
                                    <EuEcoCredits textStr="3× EcoCredits" />
                                ) : (
                                    <EuEcoCredits />
                                )}
                                <EditorLink className="name" href={item.productUrl} target="_blank">
                                    {NA_SITES.includes(locale) ? 'EcoFlow ' : ''}
                                    {item.title.replace(`(${t('product_price_member')})`, '')}
                                </EditorLink>
                                <p className="subtitle1">{item.subtitle1}</p>
                                <p className="subtitle2">{item.subtitle2}</p>
                            </div>
                            <div className="context-prices">
                                <p className="price">
                                    <span>{item.memberPrice2}</span>
                                    {Number(item.price) > Number(item.memberPrice) ? (
                                        <span className="member">{t('product_price_member')}</span>
                                    ) : (
                                        Number(item.compareAtPrice) > Number(item.price) && <span className="del">{item.compareAtPrice2}</span>
                                    )}
                                </p>
                                {Number(item.price) > Number(item.memberPrice) && (
                                    <p className="no_member_price">
                                        {item.price2}&nbsp;
                                        {t('product_price_non_member')}
                                        {Number(item.compareAtPrice) > Number(item.price) && <span className="del">{item.compareAtPrice2}</span>}
                                    </p>
                                )}

                                <p className={`tools ${(euLearnMoreBtn || locale === 'kr') && 'tools_next'}`}>
                                    {(euLearnMoreBtn || locale === 'kr') && (
                                        <EditorLink style={{ width: '100%' }} href={item.productUrl} target="_blank">
                                            <Button className="buy_button learn_more">{t('product_price_learn_more')}</Button>
                                        </EditorLink>
                                    )}
                                    {!item.checkoutNode ? (
                                        <EditorLink href={item.productUrl} target="_blank">
                                            <Button className="buy_button">{t('product_price_learn_more')}</Button>
                                        </EditorLink>
                                    ) : (
                                        <Button className="buy_button" onClick={() => handleDetail(item)}>
                                            {t('product_price_buy_now')}
                                        </Button>
                                    )}
                                </p>
                            </div>
                        </div>
                        <div className="img">
                            <EditorImg pc={imgArr[`${index}`]?.pc || item?.imageUrl} h5={imgArr[`${index}`]?.h5 || item?.imageUrl} />
                            {item.discount && (
                                <div className="off">
                                    {SAVE_SITES.includes(locale) ? (
                                        item.discount
                                    ) : locale === 'kr' ? (
                                        '당일출고'
                                    ) : (
                                        <>
                                            {item.discount}
                                            &nbsp;
                                            <span>{t('off')}</span>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HotBundles;
